import React from 'react'
import TableValueAction from '../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../Camiones/containers/busquedaCpa/InfoCpa'
import { COLORES } from '../../../../config/colores'
import DetalleDescargaConMermas from '../../containers/controlDiario/DetalleDescargaConMermas'
import DetalleCargaBuque from '../../containers/controlDiario/DetalleCargaBuque'

//* * Columnas correspondientes a control diario */
export const COL_RESUMEN_DESCARGA = [
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true,
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'entry',
    label: 'Cantidad de camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidad']
        const cereal = detalle['nombreCereal']
        const titulo = `Detalle de descarga - ${cereal}`
        const agrupado = true
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleDescargaConMermas detalle={detalle} agrupado={agrupado} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoDescarga',
    label: 'Neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  },
  {
    name: 'pesoNetoSHumedad',
    label: 'Neto s/humedad',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  },
  {
    name: 'pesoNetoStock',
    label: 'Neto total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  }
]

export const RESUMEN_DESCARGA_TO_PRINT = [
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '100'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '100'
  },
  {
    name: 'cantidad',
    label: 'Camiones',
    width: '70'
  },
  {
    name: 'pesoNetoDescarga',
    label: 'Peso neto',
    width: '100'
  },
  {
    name: 'pesoNetoSHumedad',
    label: 'Neto s/humedad',
    width: '100'
  },
  {
    name: 'pesoNetoStock',
    label: 'Peso neto total',
    width: '100'
  }
]

export const COL_REPORTE_DESCARGA = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Esportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'entry',
    label: 'Cantidad de camiones',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const value = detalle['cantidad']
        const cereal = detalle['nombreCereal']
        const exportador = detalle['razonSocialExportador']
        const titulo = `Detalle de descarga - ${cereal} - ${exportador}`
        return (
          (value > 0)
            ? <TableValueAction
              value={value}
              title={titulo}
              content={<DetalleDescargaConMermas detalle={detalle} />}
            />
            : <div style={{
              color: COLORES.grey.dark,
              fontSize: '1rem',
              width: '100%',
              fontWeight: 'bold'
            }}
            >
              {value}
            </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoDescarga',
    label: 'Neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  },
  {
    name: 'pesoNetoSHumedad',
    label: 'Neto s/humedad',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  },
  {
    name: 'pesoNetoStock',
    label: 'Neto total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  }
]

export const REPORTE_DESCARGA_TO_PRINT = [
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '100'
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '100'
  },
  {
    name: 'cantidad',
    label: 'Camiones',
    width: '70'
  },
  {
    name: 'pesoNetoDescarga',
    label: 'Peso neto',
    width: '100'
  },
  {
    name: 'pesoNetoSHumedad',
    label: 'Neto s/humedad',
    width: '100'
  },
  {
    name: 'pesoNetoStock',
    label: 'Peso neto total',
    width: '100'
  }
]

export const COL_DETALLE_DESCARGA = [
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (variedad) => {
        return ((variedad.trim() === 'UNDEF') ? '- ' : variedad)
      }
    }
  },
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (cpa) => {
        return <>
          {cpa
            ? <TableValueAction
              value={cpa}
              title=' '
              content={<InfoCpa cpa={cpa} />}
            />
            : null
          }
        </>
      }
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'fumigado',
    label: 'Fumigado',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (fumigado) => {
        return <>{fumigado ? 'Si' : 'No'}</>
      }
    }
  },
  {
    name: 'humedad',
    label: 'Humedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      customBodyRender: (humedad) => {
        return <>{humedad} %</>
      }
    }
  },
  {
    name: 'pesoNeto',
    label: 'Neto descarga',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  },
  {
    name: 'rebajaNivel0',
    label: 'Rebaja nivel 0',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return (<>{rebaja}</>)
      }
    }
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Neto s/humedad',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  },
  {
    name: 'rebajaNivel1',
    label: 'Rebaja nivel 1',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (rebaja) => {
        return (<>{rebaja}</>)
      }
    }
  },
  {
    name: 'pesoNetoNivel1',
    label: 'Neto total',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return (<>{neto} Kg.</>)
      }
    }
  }
]

export const DETALLE_DESCARGA_TO_PRINT = [
  {
    name: 'cartaDePorte',
    label: 'Carta de porte',
    width: '70'
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '120'
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '50'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '50'
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación',
    width: '70'
  },
  {
    name: 'fumigado',
    label: 'Fumigado',
    width: '50'
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: '50'
  },
  {
    name: 'pesoNeto',
    label: 'Peso neto',
    width: '50'
  },
  {
    name: 'rebajaNivel0',
    label: 'Rebaja nivel 0',
    width: '50'
  },
  {
    name: 'pesoNetoNivel0',
    label: 'Neto s/humedad',
    width: '100'
  },
  {
    name: 'rebajaNivel0',
    label: 'Rebaja nivel 0',
    width: '50'
  },
  {
    name: 'pesoNetoNivel1',
    label: 'Peso neto total',
    width: '70'
  }
]

export const COL_CARGA_DIARIA = [
  {
    name: 'fechaDeTurnoDeTrabajo',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'nombreBuque',
    label: 'Buque',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'entry',
    label: 'Peso neto',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (detalle) => {
        const peso = detalle['pesoTotal']
        const buque = detalle['nombreBuque']
        const fecha = detalle['fechaDeTurnoDeTrabajo']
        const titulo = `Detalle de carga - ${buque} - ${fecha}`
        return (
          <TableValueAction
            value={`${peso} kg.`}
            title={titulo}
            content={<DetalleCargaBuque detalle={detalle} />}
          />

        )
      }
    }
  }
]

export const CARGA_DIARIA_TO_PRINT = [
  {
    name: 'fechaDeTurnoDeTrabajo',
    label: 'Fecha',
    width: '70'
  },
  {
    name: 'nombreBuque',
    label: 'Cereal',
    width: '120'
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '120'
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '120'
  },
  {
    name: 'pesoTotal',
    label: 'Peso neto',
    width: '120'
  }
]

export const COL_DETALLE_CARGA = [
  {
    name: 'fechaDeTurnoDeTrabajo',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'nombreBuque',
    label: 'Buque',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'bodega',
    label: 'Bodega',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'pesoTotalMadrugada',
    label: 'Peso madrugada',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoTotalManana',
    label: 'Peso mañana',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoTotalTarde',
    label: 'Peso tarde',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  },
  {
    name: 'pesoTotalNoche',
    label: 'Peso noche',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  }
]

export const DETALLE_CARGA_TO_PRINT = [
  {
    name: 'fechaDeTurnoDeTrabajo',
    label: 'Fecha',
    width: '70'
  },
  {
    name: 'nombreBuque',
    label: 'Buque',
    width: '70'
  },
  {
    name: 'bodega',
    label: 'Bodega',
    width: '70'
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '70'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: '70'
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '70'
  },
  {
    name: 'pesoTotalMadrugada',
    label: 'Peso madrugada',
    width: '70'
  },
  {
    name: 'pesoTotalManana',
    label: 'Peso mañana',
    width: '70'
  },
  {
    name: 'pesoTotalTarde',
    label: 'Peso tarde',
    width: '70'
  },
  {
    name: 'pesoTotalNoche',
    label: 'Peso noche',
    width: '70'
  }
]

export const COL_VENTA_A_EXPORTADOR = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (peso) => {
        return peso > 0 ? <>{peso} kg.</> : ' - '
      }
    }
  }
]

export const VENTA_A_EXPORTADOR_TO_PRINT = [
  {
    name: 'fecha',
    label: 'Fecha',
    witdh: '70'
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    witdh: '70'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    witdh: '70'
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    witdh: '70'
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    witdh: '70'
  }
]
